import { useEffect, useState } from 'react';
import ComingSoon from './components/ComingSoon';
import PrivacyPolicy from './components/PrivacyPolicy';

// Tiny pathname-based router. CloudFront's SPA fallback (403/404 → /index.html)
// means direct deep links land here, and the path check picks the page.
function isPrivacyPath(p: string) {
  const stripped = p.replace(/\/+$/, '');
  return stripped === '/privacy' || stripped === '/personvern';
}

export default function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  return isPrivacyPath(path) ? <PrivacyPolicy /> : <ComingSoon />;
}
